module.exports = __webpack_public_path__ + "static/img/t1.6954790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/t1.png
// module id = Y7Ye
// module chunks = 1